import { render, staticRenderFns } from "./dialogResizeRootDisk.vue?vue&type=template&id=147bee4d&scoped=true"
import script from "./dialogResizeRootDisk.vue?vue&type=script&lang=js"
export * from "./dialogResizeRootDisk.vue?vue&type=script&lang=js"
import style0 from "./dialogResizeRootDisk.vue?vue&type=style&index=0&id=147bee4d&prod&lang=css"
import style1 from "./dialogResizeRootDisk.vue?vue&type=style&index=1&id=147bee4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147bee4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VDivider,VRow,VTextField})
